"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lang_1 = __importDefault(require("../../../lang"));
function base64Image() {
    return this
        .matches(/^data:image\/\w+;base64,/, (0, lang_1.default)().validation.base64ImageInvalid());
}
exports.default = base64Image;
